import { useSelector } from "react-redux";
import { AppDispatch, RootState, useAppDispatch } from "../../../../../store";
import KatakomButton from "../../../../shared/KatakomButton";
import KatakomTable from "../../../../shared/KatakomTable";
import KatakomModal from "../../../../shared/KatakomModal";
import AssetModalComponent from "./AssetModalComponentTip2";
import { useState } from "react";
import { Container, Row } from "../../../style";
import { deleteNepokretnostTip2 } from "../../../../../store/CaseTip2Reducer";

const AddAssetsTip2 = () => {
    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
    const dispatch: AppDispatch = useAppDispatch();
    const nepokretnostKN = useSelector((state: RootState) => state.caseTip2.nepokretnostKN);
    const [editingNepokretnost, setEditingNepokretnost] = useState<any>(null);

    const handleCloseModal = () => {
        setModalIsOpen(false);
    };

    const handleEditNepokretnost = (nepokretnost: any) => {
        setEditingNepokretnost(nepokretnost);
        setModalIsOpen(true);
    };

    const handleDeleteNepokretnost = (nepokretnost: any) => {
        dispatch(deleteNepokretnostTip2(nepokretnost.id));
    };

    const columns = [
        { label: "Ид", value: "id" },
        { label: "Катастарска општина", value: "koNaziv" },
        { label: "Број парцеле", value: "brojParcele" },
        { label: "Подброј парцеле", value: "podBrojParcele" },
        { label: "Број дела парцеле", value: "brojDelaParcele" },
        { label: "Удео", value: "udeo" },
        { label: "", value: "edit" },
        { label: "", value: "delete" },
    ];

    return (
        <Container>
            <KatakomModal isOpen={modalIsOpen} setIsOpen={setModalIsOpen}>
                <AssetModalComponent
                    closeModal={handleCloseModal}
                    nepokretnostId={editingNepokretnost ? editingNepokretnost.id : undefined}
                    setEditingNepokretnost={setEditingNepokretnost}
                    modalState={modalIsOpen}
                />
            </KatakomModal>
            {nepokretnostKN.length !== 0 ? (
                <div style={{ margin: "15px" }}>
                    <KatakomTable
                        columns={columns}
                        data={nepokretnostKN}
                        onEdit={handleEditNepokretnost}
                        onDelete={handleDeleteNepokretnost}
                    />
                </div>
            ) : null}

            <Row style={{ display: "flex", justifyContent: "center" }}>
                <KatakomButton
                    label={"Додај непокретност"}
                    size="l"
                    onClick={() => {
                        setModalIsOpen(true);
                    }}
                ></KatakomButton>
            </Row>
        </Container>
    );
};

export default AddAssetsTip2;
